class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);


    try {
      const cartItem = document.querySelector(`#CartItem-${line}`)
      if(cartItem){
        const { variantId, preorderType } = cartItem.dataset;
        const productId = cartItem.getAttribute('data-product-id')
        const quantityElement = cartItem.querySelector('input[data-default-value]')

        if(quantityElement){
          const defaultQuantity = quantityElement.getAttribute('data-default-value')
          if(defaultQuantity && productId && variantId && preorderType){
            if(window?.Globo?.Preorder && window?.GloboPreorderParams?.products){
              let product = window.GloboPreorderParams.products.find(product => product.id.toString() == productId)
              if(product){
                let profile = window.Globo.Preorder.getProductProfile(product, variantId, null)
                let quantityToEnd = profile?.quantity?.quantityToEnd;
                let moreQuantity = parseInt(quantity) - parseInt(defaultQuantity)
                
                if(profile?.isPreorder){
                  if(preorderType == 'preorder' && quantityToEnd && parseInt(moreQuantity) > 0 && parseInt(moreQuantity) >= parseInt(quantityToEnd)){
                    let totalQuantity = parseInt(quantityToEnd)
                    alert(profile.message.cartWarningAlertMessage.replace(':stock', quantityToEnd).replace(':max', totalQuantity))
                    quantity = totalQuantity;
                    quantityElement.value = totalQuantity
                    quantityElement.setAttribute('data-default-value', totalQuantity)
                  }
                }else{
                  if(preorderType == 'preorder' && parseInt(moreQuantity) > 0){
                    if(profile?.message?.cartWarningEndLimitMessage){
                        alert(profile?.message?.cartWarningEndLimitMessage)
                    }                                       
                    quantity = defaultQuantity;
                    quantityElement.value = defaultQuantity
                    quantityElement.setAttribute('data-default-value', defaultQuantity)
                  }
                }
              }
            }
          }
        }
      
      }
    } catch (error) {
        console.log('error: ', error)
    }


    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        document.dispatchEvent(new CustomEvent('globo.preorder.update.cart'))
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
        
        this.updateQuantityLiveRegions(line, parsedState.item_count);
        
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = theme.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    // Remove 'loaded' class from GWP cover when loading starts
    const rewardsCover = document.querySelector('.rewards-cover');
    if (rewardsCover) {
      rewardsCover.classList.remove('loaded');
    }
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
    
    // Re-add 'loaded' class to GWP cover when loading ends
    const rewardsCover = document.querySelector('.rewards-cover');
    if (rewardsCover) {
      rewardsCover.classList.add('loaded');
    }
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);

// Production version - Add this to your theme's main JS file
// This will automatically check and update cart prices on page load

(function() {
  'use strict';

  // Function to check and update cart prices
  async function checkAndUpdateCartPrices() {
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      if (!cart || !cart.items || cart.items.length === 0) {
        return; // Cart is empty
      }

      let hasChanges = false;
      const updates = {};

      // Check each item for price changes
      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        
        try {
          // Fetch current product data
          const productResponse = await fetch(`/products/${item.handle}.js`);
          const product = await productResponse.json();
          
          // Find matching variant
          const currentVariant = product.variants.find(v => v.id === item.variant_id);
          
          if (currentVariant && currentVariant.price !== item.price) {
            // Price has changed - we need to update
            hasChanges = true;
            
            // Store the line number (1-indexed) and new quantity
            // We'll update by setting quantity to 0, then re-adding
            updates[i + 1] = {
              variantId: item.variant_id,
              quantity: item.quantity,
              properties: item.properties,
              oldPrice: item.price,
              newPrice: currentVariant.price
            };
          }
        } catch (error) {
          console.error(`Error checking price for ${item.handle}:`, error);
        }
      }

      // If there are price changes, update the cart
      if (hasChanges) {
        console.log('Price changes detected, updating cart...');
        
        // Update each item by removing and re-adding
        for (const [line, update] of Object.entries(updates)) {
          try {
            // Remove item (set quantity to 0)
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                line: parseInt(line),
                quantity: 0
              })
            });

            // Re-add item with current price
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: String(update.variantId),
                quantity: update.quantity,
                properties: update.properties
              })
            });
          } catch (error) {
            console.error('Error updating cart item:', error);
          }
        }

        // Trigger cart update event to refresh UI
        const updatedCartResponse = await fetch('/cart.js');
        const updatedCart = await updatedCartResponse.json();
        
        // Dispatch custom event that your theme listens to
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: updatedCart }
        }));

        // If on cart page, reload to show updates
        if (window.location.pathname.includes('/cart')) {
          window.location.reload();
        } else {
          // Update mini-cart if it exists
          const miniCart = document.querySelector('mini-cart');
          if (miniCart && typeof miniCart.loadCart === 'function') {
            miniCart.loadCart();
          }
        }
      }
    } catch (error) {
      console.error('Error checking cart prices:', error);
    }
  }

  // Run price check when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndUpdateCartPrices);
  } else {
    checkAndUpdateCartPrices();
  }

  // Also run on cart page visits
  if (window.location.pathname.includes('/cart')) {
    window.addEventListener('load', checkAndUpdateCartPrices);
  }

})();